import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
	getRevisionsRequest: null,
	getRevisionsSuccess: ['revisions'],
	getRevisionRequest: ['id'],
	getRevisionSuccess: ['revision'],
	restoreRevisionRequest: ['id'],
})

export const revisionTypes = Types
export default Creators
